import React, {PropTypes} from 'react'
import {connect} from 'react-redux'
import {getWebapps} from 'state/actions'
import styles from './webapps.scss'
import WebAppClickableThumbBlock from './WebAppClickableThumbBlock'
import WebAppFillDocDom from './WebAppFillDocDom'
import ComponentPageDom from 'elements/ComponentPageDom'
import nesProp from 'nested-property'

import i18n from 'lib/i18n'
const _ = i18n('webapps')

const WebAppsCtDom = ({children}) => (
	<div className={styles.itemsContainer}>
		{children}
	</div>
)
WebAppsCtDom.propTypes = {
	children: React.PropTypes.node,
}

const WebAppItemDom = ({href, img, desc}) => (
	<a href={href} target="_blank" className={styles.item} rel="noopener noreferrer">
		<div className={styles.imageContainer}>
			<img src={img}/>
		</div>
		<div className={styles.descContainer}>
			<span>{desc}</span>
		</div>
	</a>
)
WebAppItemDom.propTypes = {
	href: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	desc: PropTypes.string.isRequired,
}

@connect(
    ({
        webapps,
        app: {lang, security: {WebAppTypes}}
    }) => ({
        webapps,
        lang,
        WebAppTypes
    }
))
export default class Webapp extends React.Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		webapps: PropTypes.arrayOf(PropTypes.object),
		lang: PropTypes.string.isRequired,
	}

    constructor(props) {
        super(props)

        this.state = {
            selectedApp : false
        }
    }

	componentWillMount() {
		const {dispatch, webapps} = this.props
		if (!webapps.length) {
			dispatch(getWebapps())
		}
	}

    getLangSpecificImageName(item) {
        const {lang} = this.props

        if (!item) {
            return ''
        }

        if (item.imageLang && item.imageLang[lang] && item.imageLang[lang].filename) {
            return item.imageLang && item.imageLang[lang] && item.imageLang[lang].filename
        }

        // finally if no language dependent image found try to send general image.
        return item.image && item.image.filename || ''
    }

    /**
     * This
     * @param {*} webappRecord
    */
    getLanguageSpecificLink(webappRecord) {
        let basicLink = webappRecord && webappRecord.link
        let langSpecificLink = webappRecord && webappRecord.linkFor || {}

        langSpecificLink["nl"] = langSpecificLink.nl || ''
        langSpecificLink["fr"] = langSpecificLink.fr || ''
        langSpecificLink["en"] = langSpecificLink.en || ''

        return (langSpecificLink[global.lang] || basicLink || '')
    }

    /**
     * This function will return the description in of webapp on the user language.
     * @param {*} item
     */
    getLangSpecificDescription(item) {
        const {lang} = this.props
        return nesProp.get(item, 'desc.' + lang) || ''
    }

    onSelectWebAppDocumentFill(webApp) {
        this.setState({selectedApp: webApp ? webApp : false})
    }

	render() {
		const {webapps, lang, noHeader, WebAppTypes} = this.props
        const { selectedApp } = this.state

        // prepare back button for Componenet page dom if webapp is selected
        // when the object is empty no backbutton diplayed else backbutton displayed
        let backButtonPropsForHeader = {}
        if (selectedApp) {
            backButtonPropsForHeader = {
                usesBackButton: true,
                backButtonOnClick: () => {
                    this.setState({selectedApp: false})
                },
                backButtonLabel: _("backToWebapps")
            }
        }

		return (
			<ComponentPageDom
				{...{
					noHeader,
					title: _('title'),
                    subtitle: _('subtitle'),
                    ...backButtonPropsForHeader
				}}
                extraClassName={styles.maxHeight}
                extraClassNameMainSubDiv={styles.mainSubDiv}
			>
                {selectedApp ?
                    <WebAppFillDocDom
                        webApp = {selectedApp}
                        {...{
                            img: `uploads/webapps/${this.getLangSpecificImageName(selectedApp)}`,
                            desc: this.getLangSpecificDescription(selectedApp),
                        }}
                        onSave={()=>{
                            this.setState({selectedApp: false})
                        }}
                        onCancel={()=>{
                            this.setState({selectedApp: false})
                        }}
                    />
                    :
                    <WebAppsCtDom>
                        {webapps.length > 0 ? webapps.map((item, i) => {
                                let link = this.getLanguageSpecificLink(item)

                                // when there are no language specific or general link then the web
                                // app is not visible.
                                // WEBAPP_DOCUMENT_FILLER, WEBAPP_GENERAL
                                if (!link && (!item.webAppType || item.webAppType === WebAppTypes.WEBAPP_GENERAL)) {
                                    return null
                                }

                                let image = `uploads/webapps/${this.getLangSpecificImageName(item)}`
                                let description = this.getLangSpecificDescription(item)
                                let renderedApp

                                switch(item.webAppType) {
                                    case WebAppTypes.WEBAPP_DOCUMENT_FILLER: {
                                        renderedApp  =<WebAppClickableThumbBlock
                                            webApp = {item}
                                            {...{
                                                img: image,
                                                desc: description,
                                            }}
                                            onSelect = {
                                                (selectedApp) => {
                                                    this.onSelectWebAppDocumentFill(selectedApp)
                                                }
                                            }
                                            key={"WebAppClickableThumbBlock"+i}
                                        />
                                        break
                                    }
                                    default: {
                                        renderedApp = <WebAppItemDom
                                            key={i}
                                            {...{
                                                href: link,
                                                img: image,
                                                desc: description,
                                            }}
                                        />
                                        break
                                    }
                                }

                                return renderedApp

                            }
                            ) :
                            _('comingSoon')
                        }
                    </WebAppsCtDom>
                }
			</ComponentPageDom>
		)
	}
}



// WEBPACK FOOTER //
// ./components/webapps/index.jsx